import { JSONData, Parser } from '../models/Model';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ModelParserMixin extends Vue {
  $parseModel(list: JSONData) {
    return Parser.parse(list);
  }
}
